import React, { Component } from 'react';
import { Result, Button } from 'antd';

class Error403 extends Component {
	componentDidMount() {
		document.title = "Page Not Found | Partner Portal";
	}

	render() {
		return (
			<Result
				status="403"
				title="403"
                subTitle="Sorry, you are not authorized to access this page."
				extra={<Button type="primary" onClick={e => {e.preventDefault(); this.props.history.goBack();}}>Back</Button>}
			/>
		)
	}
}

export default Error403;